export default __webpack_public_path__ + "static/media/ic_colombia.a321e669.svg";